import React from 'react';

import { styled } from '../theme';

const PageBodyFooter = styled('section')(({ theme }) => ({
    marginTop: 'auto',
    flexShrink: 0,
    background: theme.color.backgroundGray,
    padding: 30,
    paddingBottom: 0,
    overflowY: 'auto',
    display: 'flex',
    flexFlow: 'column',
}));

type Props = { children?: React.ReactNode };

export default ({ children, ...props }: Props) => (
    <PageBodyFooter data-testid="page-footer" {...props}>
        {children}
    </PageBodyFooter>
);
